import { KeyValue } from '@/main/models/common';

export enum UserHierarchyTypes {
  GET_USER_HIERARCHY = '@userHierarchy/GET_USER_HIERARCHY',
  SAVE_USER_HIERARCHY = '@userHierarchy/SAVE_USER_HIERARCHY',
  RESET_REDUCER_USER_HIERARCHY = '@userHierarchy/RESET_REDUCER_USER_HIERARCHY'
}

export interface UserHierarchyState {
  readonly userHierarchy: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetUserHierarchy {
  type: typeof UserHierarchyTypes.GET_USER_HIERARCHY;
  payload: {
    guidInsurer: string;
    idSystemApplication: number;
  };
}

export interface SaveUserHierarchy {
  type: typeof UserHierarchyTypes.SAVE_USER_HIERARCHY;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerUserHierarchy {
  type: typeof UserHierarchyTypes.RESET_REDUCER_USER_HIERARCHY;
}

export type UserHierarchyActionTypes =
  | GetUserHierarchy
  | SaveUserHierarchy
  | ResetReducerUserHierarchy;
